import React, {Suspense, useEffect} from 'react';
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import useTitleAndDescription from "../../../common/hooks/useTitleAndDescription";
import {Footer, Header, Loading} from "../../common";
import {ErrorBoundary} from "react-error-boundary";
import CenterContentBox from "../../Champions/ContentWrapper";
import BottomStickAd from "../../ad/BottomStickAd";
import CustomClanDetailContent from "./CustomClanDetailContent";

const Wrapper = styled.div`
`;

const ContentWrapper = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;


function Fallback({error, resetErrorBoundary}) {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.

    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre>{error.message}</pre>
        </div>
    );
}

const CustomClanDetail = () => {
    const {t} = useTranslation();
    useTitleAndDescription({
        title: 'Connect | Deeplol.gg',
        description: '(클랜/크루/스트리머) (모임이름)의 롤 내전 전적과 멤버 스탯을 확인하세요. Deeplol Connect에서 제공하는 실시간 내전 데이터와 모임 소개를 만나보세요!',
    })

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    return (
        <Wrapper>
            <Header/>
            <ContentWrapper>
                <ErrorBoundary FallbackComponent={Fallback}>
                    <CenterContentBox disableSponsor={true}>
                        <Suspense fallback={<Loading/>}>
                            <CustomClanDetailContent/>
                        </Suspense>
                        {/*    <NewsContent/>*/}
                    </CenterContentBox>
                </ErrorBoundary>
            </ContentWrapper>
            <Footer/>
            <BottomStickAd/>
        </Wrapper>
    );
};



export default CustomClanDetail;